/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAggregateRoomMetricsForCompanyRequestFilterFromJSON(json) {
    return StreemApiAggregateRoomMetricsForCompanyRequestFilterFromJSONTyped(json, false);
}
export function StreemApiAggregateRoomMetricsForCompanyRequestFilterFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userSid': !exists(json, 'user_sid') ? undefined : json['user_sid'],
        'groupSid': !exists(json, 'group_sid') ? undefined : json['group_sid'],
        'groupName': !exists(json, 'group_name') ? undefined : json['group_name'],
    };
}
export function StreemApiAggregateRoomMetricsForCompanyRequestFilterToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user_sid': value.userSid,
        'group_sid': value.groupSid,
        'group_name': value.groupName,
    };
}
//# sourceMappingURL=StreemApiAggregateRoomMetricsForCompanyRequestFilter.js.map